import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useRestoreLesson = ({ onSuccess }: { onSuccess: () => void }) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: { id: string }) =>
      httpService.panel.panelLessonsUncancelCreate(data.id),
    onSuccess
  })

export default useRestoreLesson
